/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createDafUpload } from '../fn/daf/create-daf-upload';
import { CreateDafUpload$Params } from '../fn/daf/create-daf-upload';
import { DafUpload } from '../models/daf-upload';
import { DafUploadPagedList } from '../models/daf-upload-paged-list';
import { getDafUpload } from '../fn/daf/get-daf-upload';
import { GetDafUpload$Params } from '../fn/daf/get-daf-upload';
import { processDafFiles } from '../fn/daf/process-daf-files';
import { ProcessDafFiles$Params } from '../fn/daf/process-daf-files';
import { searchDafUploadList } from '../fn/daf/search-daf-upload-list';
import { SearchDafUploadList$Params } from '../fn/daf/search-daf-upload-list';
import { uploadDafFile } from '../fn/daf/upload-daf-file';
import { UploadDafFile$Params } from '../fn/daf/upload-daf-file';


/**
 * All about the DAF business
 */
@Injectable({ providedIn: 'root' })
export class DafService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createDafUpload()` */
  static readonly CreateDafUploadPath = '/custom/daf/uploads';

  /**
   * Allow to create a DAF Upload item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createDafUpload()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDafUpload$Response(params: CreateDafUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createDafUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * Allow to create a DAF Upload item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createDafUpload$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createDafUpload(params: CreateDafUpload$Params, context?: HttpContext): Observable<void> {
    return this.createDafUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getDafUpload()` */
  static readonly GetDafUploadPath = '/custom/daf/uploads/{uid}';

  /**
   * Get an DAF Upload.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDafUpload()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDafUpload$Response(params: GetDafUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<DafUpload>> {
    return getDafUpload(this.http, this.rootUrl, params, context);
  }

  /**
   * Get an DAF Upload.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDafUpload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDafUpload(params: GetDafUpload$Params, context?: HttpContext): Observable<DafUpload> {
    return this.getDafUpload$Response(params, context).pipe(
      map((r: StrictHttpResponse<DafUpload>): DafUpload => r.body)
    );
  }

  /** Path part for operation `uploadDafFile()` */
  static readonly UploadDafFilePath = '/custom/daf/uploads/{uid}/upload';

  /**
   * Upload a file for DAF.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `uploadDafFile()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadDafFile$Response(params: UploadDafFile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return uploadDafFile(this.http, this.rootUrl, params, context);
  }

  /**
   * Upload a file for DAF.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `uploadDafFile$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  uploadDafFile(params: UploadDafFile$Params, context?: HttpContext): Observable<void> {
    return this.uploadDafFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `processDafFiles()` */
  static readonly ProcessDafFilesPath = '/custom/daf/uploads/process';

  /**
   * Process all files for DAF.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `processDafFiles()` instead.
   *
   * This method doesn't expect any request body.
   */
  processDafFiles$Response(params?: ProcessDafFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return processDafFiles(this.http, this.rootUrl, params, context);
  }

  /**
   * Process all files for DAF.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `processDafFiles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  processDafFiles(params?: ProcessDafFiles$Params, context?: HttpContext): Observable<void> {
    return this.processDafFiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchDafUploadList()` */
  static readonly SearchDafUploadListPath = '/custom/daf/uploads/search';

  /**
   * Retrieve a DAF Upload list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchDafUploadList()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchDafUploadList$Response(params?: SearchDafUploadList$Params, context?: HttpContext): Observable<StrictHttpResponse<DafUploadPagedList>> {
    return searchDafUploadList(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a DAF Upload list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchDafUploadList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchDafUploadList(params?: SearchDafUploadList$Params, context?: HttpContext): Observable<DafUploadPagedList> {
    return this.searchDafUploadList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DafUploadPagedList>): DafUploadPagedList => r.body)
    );
  }

}
